import { RuntimeConfig } from "@/models/RuntimeConfig";
import axios from "axios";
import { ref } from "vue";
const version = process.env.PACKAGE_VERSION;

const devMode = process.env.NODE_ENV !== 'production';
const config = ref<RuntimeConfig>({
    apiBaseUrl: "https://api.islesofscilly-travel.co.uk/api/v1/",
    cmsBaseUrl: "https://islesofscilly-travel.co.uk/wp-json/",
    bookUrl: "https://islesofscilly-travel.co.uk/newbook",
    accountUrl: "https://islesofscilly-travel.co.uk/account",
    agentAccountUrl: "https://islesofscilly-travel.co.uk/agentlogin",
    accommodationUrl: "https://islesofscilly-travel.co.uk/newbook"
})
const read = ref(false);

const useRuntimeConfig = () => {
    const getRuntimeConfig = async (): Promise<RuntimeConfig> => {
        if (read.value) return config.value;

        const runtimeConfig = await axios.get(devMode ? '/runtimeConfig.development.json?' + version : '/dist/runtimeConfig.json?' + version);
        const json = runtimeConfig.data;

        config.value = {
            apiBaseUrl: json.api_base_url,
            cmsBaseUrl: json.cms_base_url,
            bookUrl: json.book_url,
            accountUrl: json.account_url,
            agentAccountUrl: json.agent_account_url,
            accommodationUrl: json.accommodation_url
        }

        read.value = true;

        return config.value;
    }

    return {
        getRuntimeConfig
    }
}

export default useRuntimeConfig;